import { PAGE_TYPE } from '_constants/location';
import { STORAGE_KEYS } from '_constants/storage';
import { ROUTES } from '_constants/routes';
import {
  storeLocalValue,
  restoreLocalValue,
  storeSessionValue,
} from '_helpers/storage';
import { initFingerprint } from '_helpers/fingerprint';

const buildClickURLObject = (query = {}) => {
  const { gclid, source, keyword, adAccount } = query;

  const url = window.location.href;
  const page = url.split('?')[0].replace(/\/?$/, '') || '/';

  return {
    url,
    page,
    ...(gclid && { clid: gclid.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(source && { source: source.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(keyword && {
      keyword: keyword.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join(''),
    }),
    ...(adAccount && {
      adAccount: adAccount.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join(''),
    }),
  };
};

export const initVisitTracking = (location) => {
  if (typeof window === 'undefined') return;

  const { gclid, source, keyword, adAccount } = location.query || {};
  const hasTrackingParams = gclid || source || keyword || adAccount;

  if (hasTrackingParams) {
    storeSessionValue(STORAGE_KEYS.saleURL, buildClickURLObject(location.query));
  }

  if (restoreLocalValue(STORAGE_KEYS.firstClickURL)) return;

  storeLocalValue(STORAGE_KEYS.firstClickURL, buildClickURLObject(location.query));
};

export const createClickBody = (location, device) => {
  const { gclid, source, keyword, adAccount } = location.query || {};

  if (gclid) {
    storeLocalValue(
      STORAGE_KEYS.gclid,
      gclid.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')
    );
  }

  if (source) {
    storeLocalValue(
      STORAGE_KEYS.source,
      source.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')
    );
  }

  if (keyword) {
    storeLocalValue(
      STORAGE_KEYS.keyword,
      keyword.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')
    );
  }

  if (adAccount) {
    storeLocalValue(
      STORAGE_KEYS.adAccount,
      adAccount.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('')
    );
  }

  initFingerprint();

  const click = {
    device,
    pageType: PAGE_TYPE.presellPage,
    requestUri: window.location.href,
    fingerprint: restoreLocalValue(STORAGE_KEYS.fingerprint) || undefined,
  };

  if (adAccount || keyword || source || gclid) {
    storeLocalValue(STORAGE_KEYS.requestUri, window.location.href);
  }

  if (
    restoreLocalValue(STORAGE_KEYS.requestUri)?.includes(window.location.href)
  ) {
    click.requestUri = restoreLocalValue(STORAGE_KEYS.requestUri);
  }

  if (location.pathname.includes(ROUTES.optInGeneral)) {
    click.pageType = PAGE_TYPE.leadPage;
  }

  if (location.pathname.includes(ROUTES.optInBookkeeping)) {
    click.pageType = PAGE_TYPE.leadPage;
  }

  if (location.pathname.includes(ROUTES.optInTaxPreparation)) {
    click.pageType = PAGE_TYPE.leadPage;
  }

  if (location.pathname.includes(ROUTES.payment)) {
    click.pageType = PAGE_TYPE.checkoutPage;
  }

  if (location.pathname.includes(ROUTES.upsell)) {
    click.pageType = PAGE_TYPE.upsellPage;
  }

  if (location.pathname.includes(ROUTES.thankyou)) {
    click.pageType = PAGE_TYPE.thankyouPage;
  }

  if (
    restoreLocalValue(STORAGE_KEYS.crmSessionId) &&
    click.pageType !== PAGE_TYPE.presellPage
  ) {
    click.crmSessionId = restoreLocalValue(STORAGE_KEYS.crmSessionId);
  }

  return click;
};
